// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:52:30

export default {
  "id": "daring-jack",
  "slug": "daring-jack",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/f3284e8fa0674b60b503f82c53178d75-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/f3284e8fa0674b60b503f82c53178d75/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Daring Jack",
      "description": "Jack, an adventurer, was flying over the sea in his small aircraft. When he reached a jungle island, his aircraft's engine failed and he lost control. He escaped from the crashing aircraft, landed safely on the island, and now must find a boat to leave.\n\nHe knows of the old boathouse on the island but is uncertain how to reach it. Guide him through the jungle to the boathouse. Help him gather items for survival, focusing on securing food and shelter while navigating the challenging terrain.",
      "instructions": "Using mouse or tap to control",
      "genres": [
        "Adventure",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "arcade",
        "escape",
        "forest",
        "jungle"
      ]
    },
    "zh-CN": {
      "title": "勇敢的杰克",
      "description": "杰克，一位探险家，正驾驶着他的小型飞机在海上飞行。当他抵达一个丛林岛屿时，飞机的引擎故障，他失去了控制。他从坠毁的飞机中逃脱，安全地降落在岛上，现在必须找到一艘船离开。\n\n他听说过岛上的老船屋，但不确定如何到达那里。引导他穿过丛林到达船屋。帮助他收集生存必需品，专注于确保食物和庇护所，同时在这片崎岖的地形中导航。",
      "instructions": "使用鼠标或点击操作控制",
      "genres": [
        "冒险",
        "解谜"
      ],
      "tags": [
        "1玩家",
        "街机",
        "逃脱",
        "森林",
        "丛林"
      ]
    },
    "zh-TW": {
      "title": "勇闖俠客",
      "description": "杰克，一名冒險家，正在他小型飛機上飛越海洋。當他到達一個熱帶雨林島嶼時，飛機的引擎失靈，他失去了控制。他從墜落的飛機中逃出，安全地降落於島嶼上，現在他必須找到一艘船離開。\n\n他知道島上有個舊的船屋，但確不定該如何前往。引導他穿過熱帶雨林到達船屋。幫助他收集生存物品，著重於確保食物和住所，同時在挑戰性地形中航行。",
      "instructions": "使用滑鼠或點擊控制",
      "genres": [
        "冒險",
        "謎題"
      ],
      "tags": [
        "1玩家",
        "街機",
        "逃離",
        "森林",
        "叢林"
      ]
    },
    "zh-HK": {
      "title": "膽敢的杰克",
      "description": "Jack，一位冒險家，正在他的小型飛機上飛越海洋。當他來到一個熱帶島嶼時，飛機的引擎失靈，他失去了控制。他從墜毀的飛機中逃出，安全地降落在島上，現在必須找到一艘船離開。\n\n他知道島上有個舊的船屋，但不确定該如何到達。引導他穿越熱帶森林到船屋。幫助他收集生存必需品，重點是確保食物和住所，同時在挑戰性地形中尋找方向。",
      "instructions": "使用滑鼠或點擊控制",
      "genres": [
        "冒險",
        "謎題"
      ],
      "tags": [
        "1人遊戲",
        "街機",
        "逃離",
        "森林",
        "叢林"
      ]
    },
    "ja": {
      "title": "大胆のジャック",
      "description": "ジャック、冒険者は小さな飛行機で海を飛び回っていた。ジャングルの島に到着したとき、飛行機のエンジンが故障し、コントロールを失った。彼は墜落する飛行機から逃げ出し、無事に島に着陸し、今は船を見つけて離れなければならない。\n\n島には古いボートハウスがあることを知っているが、どうやってそこまで行けばいいか不安だ。ジャングルを通ってボートハウスに導いてほしい。彼が生存のためのアイテムを集める手助けをし、困難な地形を進みながら食糧や住処を確保することに焦点を当ててほしい。",
      "instructions": "マウスを使用したりタップして操作してください",
      "genres": [
        "アドベンチャー",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "アーケード",
        "エスケープ",
        "森",
        "ジャングル"
      ]
    },
    "ko": {
      "title": "무서운Jack",
      "description": "잭, 모험가는 작은 항공기로 바다 위를 날아다니고 있었습니다. 그는 고원 섬에 도착했을 때, 항공기 엔진이 고장 나고 통제를 잃었습니다. 그는 추락하는 항공기에서 탈출하여 안전하게 섬에 착륙했고, 지금은 배를 찾아야 합니다.\n\n그는 섬에 있는 옛 배를 만드는 집을 알고 있지만, 그곳으로 가는 방법에 대해 불확실합니다. 그를 숲을 통해 배를 만드는 집으로 안내해 주세요. 생존을 위해 물건을 모으는 도움을 주세요. 심각한 지형을 지나면서 음식과 보금자리를 확보하세요.",
      "instructions": "마우스 사용 또는 탭으로 제어",
      "genres": [
        "冒険",
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "아케이드",
        "탈출",
        "숲",
        "지푸리"
      ]
    },
    "fr": {
      "title": "Osé Jack",
      "description": "Jack, un aventurier, survolait la mer dans son petit avion. Lorsqu'il atteignit une île de jungle, le moteur de son avion a lâché et il a perdu le contrôle. Il a réussi à s'échapper de l'avion en train de s'écraser, s'est posé en sécurité sur l'île, et doit maintenant trouver un bateau pour partir.\n\nIl connaît l'ancien hangar à bateaux de l'île mais n'est pas sûr de la manière d'y parvenir. Guide-le à travers la jungle jusqu'au hangar. Aidez-le à rassembler des articles pour la survie, en vous concentrant sur la sécurisation de la nourriture et de l'abri tout en naviguant à travers le terrain difficile.",
      "instructions": "Utilisez la souris ou appuyez pour contrôler",
      "genres": [
        "Aventure",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "arcade",
        "évasion",
        "forêt",
        "jungle"
      ]
    }
  }
};
